export const rowSizes = {
  sm: 35,
  md: 65,
  lg: 90,
  xl: 125,
};

export const linesCountByRowSize = {
  sm: 1,
  md: 2,
  lg: 4,
  xl: 6,
};
